(function() {
  const initTabsWithCollections = () => {
    const tabsParent = $(".tabs-with-products");
    const tabs = tabsParent.find(".twp__tabs-item");
    const tabsContent = tabsParent.find(".twp__content-item");

    tabs.on("click", function() {
      if (!$(this).is("[data-active]")) {
        const tabIndex = $(this).index();

        // Remove active state from all tabs
        $(this).parent().find("[data-active]").removeAttr("data-active");
        // Add active state to clicked tab
        $(this).attr("data-active", "");

        // Hide all content items
        tabsContent.hide();
        // Show the corresponding content item
        tabsContent.eq(tabIndex).fadeIn(300).css("display", "block");
      }
    });

    tabsParent.each(function(index, elem) {
      const tabsSlider = elem.querySelector(".twp__tabs");
      const tabsPrev = elem.querySelector(".twp__prev");
      const tabsNext = elem.querySelector(".twp__next");

      if (tabsSlider) {
        let slider = new Swiper(tabsSlider, {
          slidesPerView: 'auto',
          spaceBetween: 32,
          freeMode: true,
          navigation: {
            nextEl: tabsNext,
            prevEl: tabsPrev,
          },
          breakpoints: {
            990: {
              spaceBetween: 64
            }
          }
        });
      }
    });
  }

  initTabsWithCollections();

  document.addEventListener("shopify:section:load", function () {
    initTabsWithCollections();
  });
})();

